const formatarTelefone = (celular) => {
    if(!celular) {
        return "";
    }

    celular = celular.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replaceAll("_", "");

    return celular;
}

const formatarCpf = (cpf) => {
    if(!cpf) {
        return "";
    }

    cpf = cpf.replace("-", "").replaceAll(".", "");

    return cpf;
}

const formatarCnpj = (cnpj) => {
    if (!cnpj) {
        return "";
    }

    return cnpj.replace(/[^a-zA-Z0-9]/g, "");
};

const formatarNumero = (valor) => {
    if (!valor) {
        return "";
    }

    // Remove tudo que não for número
    return valor.replace(/\D/g, "");
}

export { formatarTelefone, formatarCpf, formatarCnpj, formatarNumero };